import styled from 'styled-components';

import type { DiagnosisRelationshipBadgeVariant } from 'widgets/results/diagnosis.utils';
import { colors } from 'styles';
import { MASKED_TEXT_CLASS } from 'analytics';

const RELATIONSHIP_BADGE_COLORS: Record<
  DiagnosisRelationshipBadgeVariant,
  { background: string; foreground: string }
> = {
  replaces: { background: colors.vantisOrange, foreground: colors.secondaryForeground },
  duplicate: { background: colors.secondary, foreground: colors.secondaryForeground },
  moreGeneral: { background: colors.secondary, foreground: colors.secondaryForeground },
  similar: { background: colors.secondary, foreground: colors.secondaryForeground },
  new: { background: colors.vantisViolet, foreground: colors.primaryForeground },
};

export const DiagnosisRelationshipBadgeItem = styled.span.attrs<{
  $variant: DiagnosisRelationshipBadgeVariant;
}>({
  className: `inline-flex items-center gap-1 mx-2 px-2 py-0.5 text-xs font-medium rounded-sm shrink-0 ${MASKED_TEXT_CLASS}`,
})<{ $variant: DiagnosisRelationshipBadgeVariant }>`
  background-color: ${({ $variant }) => RELATIONSHIP_BADGE_COLORS[$variant].background};
  color: ${({ $variant }) => RELATIONSHIP_BADGE_COLORS[$variant].foreground};
`;
